<template>
  <Layout>
    <slot name="default" />
    <Cart />
  </Layout>
</template>

<script>
import Layout from 'Web/Layouts/Default.vue';
import Cart from 'Web/Shared/Cart.vue';

export default {
  inheritAttrs: false,
  components: {
    Layout,
    Cart,
  },
}
</script>
